'use client';

import { createContext, useContext, useMemo, useState } from 'react';
import { PartList } from 'services/availabilityBySource/types';

export type productDetailPageContextProp = {
  quantity: number;
  setQuantity: (quantity: number) => void;
  locale: string;
  storeId: string;
  langId: string;
  partsList: PartList[];
  setPartsList: (partsList: PartList[]) => void;
  isPCCHeadlessAvailabilityFlag: boolean;
  isCustomerSupportEnabled: boolean;
  helpCenterContactSupportUrl: 'string';
};

export const ProductDetailPageContext =
  createContext<productDetailPageContextProp>({
    quantity: 1,
    setQuantity: () => null,
    locale: null,
    storeId: null,
    langId: null,
    partsList: [],
    setPartsList: () => null,
    isPCCHeadlessAvailabilityFlag: false,
    isCustomerSupportEnabled: false,
    helpCenterContactSupportUrl: null
  });

export const useProductDetailPageContext = () =>
  useContext(ProductDetailPageContext);

export const ProductDetailPageContextProvider = ({ children, value }) => {
  const [quantity, setQuantity] = useState(1);
  const [partsList, setPartsList] = useState([]);
  const pdpProps = useMemo(() => {
    return {
      ...value,
      quantity,
      setQuantity,
      partsList,
      setPartsList
    };
  }, [value, quantity, partsList, setQuantity]);

  return (
    <ProductDetailPageContext.Provider value={pdpProps}>
      {children}
    </ProductDetailPageContext.Provider>
  );
};
